import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
})
export class TermsAndConditionsComponent {
  constructor(private translate: TranslateService) {}

  get isArabic(): boolean {
    return (this.translate.currentLang || '').split('-')[0] === 'ar';
  }
}
